// Bounded Voronoi cells around cluster centers, clipped to the map viewport.
export function clusterRegions(clusters) {
  const centers = clusters.map((row, index) => {
    const duplicates = clusters.filter(other => other.x === row.x && other.y === row.y);
    const angle = index * 2.399963;
    return { ...row, x: duplicates.length > 1 ? Math.max(-.96, Math.min(.96, row.x)) + .025 * Math.cos(angle) : row.x,
      y: duplicates.length > 1 ? Math.max(-.96, Math.min(.96, row.y)) + .025 * Math.sin(angle) : row.y };
  });
  return centers.map(center => {
    let polygon = [[-1, -1], [1, -1], [1, 1], [-1, 1]];
    centers.forEach(other => {
      if (other.id === center.id || !polygon.length) return;
      const a = other.x - center.x, b = other.y - center.y;
      const c = (other.x ** 2 + other.y ** 2 - center.x ** 2 - center.y ** 2) / 2;
      const clipped = [];
      polygon.forEach((p, i) => {
        const q = polygon[(i + 1) % polygon.length];
        const dp = a * p[0] + b * p[1] - c, dq = a * q[0] + b * q[1] - c;
        if (dp <= 1e-10) clipped.push(p);
        if ((dp < 0 && dq > 0) || (dp > 0 && dq < 0)) {
          const t = dp / (dp - dq);
          clipped.push([p[0] + t * (q[0] - p[0]), p[1] + t * (q[1] - p[1])]);
        }
      });
      polygon = clipped;
    });
    return { ...center, polygon };
  });
}

export function donutSectors(clusters) {
  const total = clusters.reduce((sum, row) => sum + row.messages, 0);
  let angle = -Math.PI / 2;
  const polar = (radius, a) => [440 + radius * Math.cos(a), 255 + radius * Math.sin(a)].join(',');
  return clusters.filter(row => row.messages > 0).map(row => {
    const start = angle;
    const span = row.messages / total * 2 * Math.PI;
    angle += span;
    // Two arcs also support a full ring (one cluster).
    const mid = start + span / 2, end = start + span;
    const path = `M${polar(200, start)} A200,200 0 0 1 ${polar(200, mid)} A200,200 0 0 1 ${polar(200, end)} L${polar(126, end)} A126,126 0 0 0 ${polar(126, mid)} A126,126 0 0 0 ${polar(126, start)} Z`;
    return { ...row, path, labelX: 440 + 164 * Math.cos(mid), labelY: 255 + 164 * Math.sin(mid) };
  });
}
